import defaultStressFeatures from '@/app/[locale]/stress/_data/stressFeatures';
import trustedAdvisorStressFeatures from '@/app/[locale]/stress/_data/trustedAdvisorStressFeatures';
import type { LandingPageFeature } from '@/app/components/LandingPage/LandingPageFeatures/types';

const getStressFeatures = (
  isTrustedAdvisorEnabled: boolean,
): LandingPageFeature[] => {
  if (isTrustedAdvisorEnabled) {
    return trustedAdvisorStressFeatures;
  }
  return defaultStressFeatures;
};

export default getStressFeatures;
